import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService, UserService } from '@app/services';

type AdminRouteData = {
  permission?: string;
  superAdminOnly?: boolean;
};

export const adminAccessGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const permissionService = inject(PermissionService);
  const data = route.data as AdminRouteData;

  const userResponse = await userService.getUser();
  const user = userResponse?.data?.[0];

  if (!user?.id) {
    await router.navigate(['/error']);
    return false;
  }

  if (user.is_super_admin) {
    return true;
  }

  if (!user.is_admin) {
    await router.navigate(['/error']);
    return false;
  }

  if (data.superAdminOnly) {
    await router.navigate(['/error']);
    return false;
  }

  if (!data.permission) {
    return true;
  }

  const hasPermission = await permissionService.checkPermissionByAdminId(data.permission, user.id);
  if (!hasPermission) {
    await router.navigate(['/error']);
    return false;
  }

  return true;
};
